import api from './index';
export const getCategoryTree = () => {
    return api.get('/admin/categories/tree');
};
export const createCategory = (data) => {
    return api.post('/admin/categories', data);
};
export const updateCategory = (id, data) => {
    return api.put(`/admin/categories/${id}`, data);
};
export const deleteCategory = (id) => {
    return api.delete(`/admin/categories/${id}`);
};
export const changeCategoryStatus = (id, status) => {
    return api.put(`/admin/categories/${id}/status`, null, { params: { status } });
};
export const changeCategorySort = (id, sort) => {
    return api.put(`/admin/categories/${id}/sort`, null, { params: { sort } });
};
export const getSpuPage = (params) => {
    return api.get('/admin/products', { params });
};
export const getSpuDetail = (id) => {
    return api.get(`/admin/products/${id}`);
};
export const createSpu = (data) => {
    return api.post('/admin/products', data);
};
export const updateSpu = (id, data) => {
    return api.put(`/admin/products/${id}`, data);
};
export const deleteSpu = (id) => {
    return api.delete(`/admin/products/${id}`);
};
export const changeSpuStatus = (id, status) => {
    return api.put(`/admin/products/${id}/status`, null, { params: { status } });
};
export const listSkus = (spuId) => {
    return api.get(`/admin/products/${spuId}/skus`);
};
export const createSku = (spuId, data) => {
    return api.post(`/admin/products/${spuId}/skus`, data);
};
export const updateSku = (id, data) => {
    return api.put(`/admin/skus/${id}`, data);
};
export const deleteSku = (id) => {
    return api.delete(`/admin/skus/${id}`);
};
export const changeSkuStatus = (id, status) => {
    return api.put(`/admin/skus/${id}/status`, null, { params: { status } });
};
export const changeSkuCommission = (id, enabled) => {
    return api.put(`/admin/skus/${id}/commission-enabled`, null, { params: { enabled } });
};
export const exportSkuCsv = (params) => {
    return api.get('/admin/products/export', { params, responseType: 'blob' });
};
